import Icon from "@material-ui/core/Icon";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@mui/material";
import Card from "components/UI/Card/Card.js";
import CardBody from "components/UI/Card/CardBody.js";
import CardHeader from "components/UI/Card/CardHeader.js";

import ArrowForwardIos from "@material-ui/icons/ArrowForwardIos";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import CardIcon from "components/UI/Card/CardIcon.js";
import ButtonTS from "components/Forms/CustomButtons/ButtonTS";
import ReactTable from "components/Tables/ReactTable/ReactTable";
import { useNavigate } from "react-router-dom";
import {
  DashboardWorkItem,
  DashboardWorkItemsStatResponse,
} from "services/input-core/dashboard/dashboard";
import { ProfileEnum } from "utils/@types";
import { WorkItemProfiles } from "helpers/profileEnum";
import { ProfileTab } from "enums/ProfileTabs";
import { useSubscription } from "store/auth/auth-store";
import { useTranslation } from "react-i18next";

const styleAny: any = styles;
const useStyles = makeStyles(styleAny);

interface ActivitiesNeedManualApprovalProps {
  processes: DashboardWorkItemsStatResponse;
  isLoading: boolean;
}

export function ActivitiesNeedManualApproval({
  processes,
  isLoading,
}: ActivitiesNeedManualApprovalProps) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { isKuo } = useSubscription();
  const { t } = useTranslation("dashboard");

  function redirectToProfile(process: DashboardWorkItem) {
    const date = new Date(process.activityItemDueDate);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    if (isKuo && process?.profile !== ProfileEnum.WORKER) {
      return navigate(
        `../${WorkItemProfiles["SOWADM"]}/profile?id=${process.requestParam}&tab=${ProfileTab.ACTIVITY_ITEMS}&month=${month}&year=${year}&activity=${process.type}`,
      );
    }

    navigate(
      `../${WorkItemProfiles[process.profile as never]}/profile?id=${
        process.requestParam
      }&tab=${ProfileTab.ACTIVITY_ITEMS}&month=${month}&year=${year}&activity=${
        process.type
      }`,
    );
  }

  const columns: {
    Header: string;
    accessor: string;
  }[] = [
    {
      Header: t("type"),
      accessor: "type",
    },
    {
      Header: t("name"),
      accessor: "activityItemDescription",
    },
    {
      Header: t("ID"),
      accessor: "requestParam",
    },
    {
      Header: t("due-date"),
      accessor: "activityItemDueDate",
    },
    {
      Header: t("supplier"),
      accessor: "supplierName",
    },
    {
      Header: t("actions"),
      accessor: "actions",
    },
  ];

  const dataFormatted = processes?.workItemsNeedManualApproval?.map(
    (process) => {
      return {
        ...process,
        activityItemDescription: process.activityItem?.activityItemDescription,
        supplierName: process?.supplier?.supplierName,
        activityItemDueDate: new Date(
          process.activityItemDueDate,
        )?.toLocaleDateString(),
        actions: (
          <div className="actions-right">
            <ButtonTS
              justIcon
              round
              color="info"
              size="sm"
              onClick={() => redirectToProfile(process)}
            >
              <ArrowForwardIos />
            </ButtonTS>
          </div>
        ),
      };
    },
  );

  return (
    <div>
      <Card>
        <CardHeader color="warning" icon>
          <CardIcon color="warning">
            <Icon>{"search"}</Icon>
          </CardIcon>
          <h4 className={classes.cardIconTitle}>
            {t("activities-need-manual-approval")}
          </h4>
        </CardHeader>
        <CardBody>
          {isLoading ? (
            <Skeleton />
          ) : (
            <ReactTable
              id="activities-requiring-manual-validation-table"
              columns={columns}
              data={dataFormatted || []}
              fixedPageSize
              columnsNotTrimFilters={[
                "activityItemDescription",
                "supplierName",
              ]}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
}
